
export default class featuredMedia {

    constructor($element) {
        this.$video = $element;
    }

    init() {

        $('[data-video-mute]').on('click', (el) => {
            el.stopPropagation();
            $(el.currentTarget).toggleClass('fs-video__bars--muted');

            let muted = $(el.currentTarget).hasClass('fs-video__bars--muted');
            this.$video.prop('muted', muted);
        });
    }

    pause() {
      if(this.playing()) {
        this.$video[0].pause();
      }
    }

    play() {
      this.$video[0].play();
    }

    restart() {
      if(this.playing()) {
        this.$video[0].pause();
      }
      if (!isNaN(this.$video[0].duration)) {
        this.$video[0].currentTime = 0;
        this.$video[0].play();
      }

    }

    seek(e) {
        let offset = $(this.seekBar).offset();
        let left = (e.pageX - offset.left);
        let totalWidth = $(this.seekBar).width();
        let percentage = ( left / totalWidth );
        let vidTime = this.$video[0].duration * percentage;
        this.$video[0].currentTime = vidTime;
    }
    playing() {
        return !!(this.$video[0].currentTime > 0 && !this.$video[0].paused && !this.$video[0].ended && this.$video[0].readyState > 2);
    }

    destroy() {
        window.video = null;

        if(this.playing()) {
          this.$video[0].pause();
        }
        //this.$video[0].children('source').prop('src', '');
        if (typeof this.$video[0].remove !== "undefined") {
          this.$video[0].remove();
        }
        //this.$video[0].src = ''; // empty source
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/featured-media.js